const sepaPhoneValidators = [
    {country: "AT", regex: "^\\+43(6[56789]\\d{4,10})$"}, // Austria
    {country: "BE", regex: "^\\+32(4[5-9]\\d{7})$"}, // Belgio
    {country: "BG", regex: "^\\+359(8[7-9])\\d{7}$"}, // Bulgaria
    {country: "HR", regex: "^\\+385(9[1-9]\\d{6})$"}, // Croazia
    {country: "CY", regex: "^\\+357(9[5|6|7|9]\\d{6})$"}, // Cipro
    {country: "CZ", regex: "^\\\\+420?(60[1-8]|7[023-9])\\\\d{6}$"}, // Repubblica Ceca
    {country: "DK", regex: "^\\+45([2-7]\\d{7})$"}, // Danimarca
    {country: "EE", regex: "^\\+372(5\\d{7})$"}, // Estonia
    {country: "FI", regex: "^\\+358(4[0-9]|50)\\d{4,8}$"}, // Finlandia
    {country: "FR", regex: "^\\+33(6|7)\\d{8}$"}, // Francia
    {country: "DE", regex: "^\\+49(1[5-7]\\d{7,8})$"}, // Germania
    {country: "GR", regex: "^\\+30(6\\d{9})$"}, // Grecia
    {country: "HU", regex: "^\\+36(20|30|70)\\d{7}$"}, // Ungheria
    {country: "IS", regex: "^\\+354(6\\d{6})$"}, // Islanda
    {country: "IE", regex: "^\\+353(8[3-9]\\d{7})$"}, // Irlanda
    {country: "IT", regex: "^\\+39(3\\d{2})\\d{7,8}$"}, // Italia
    {country: "LV", regex: "^\\+371(2\\d{7})$"}, // Lettonia
    {country: "LI", regex: "^\\+423(6[0-9]\\d{5,8})$"}, // Liechtenstein
    {country: "LT", regex: "^\\+370(6\\d{7}|5\\d{6,7})$"}, // Lituania
    {country: "LU", regex: "^\\+352(6\\d{8})$"}, // Lussemburgo
    {country: "MT", regex: "^\\+356(79|99)\\d{6}$"}, // Malta
    {country: "MC", regex: "^\\+377(6\\d{8})$"}, // Monaco
    {country: "NL", regex: "^\\+31(6\\d{8})$"}, // Paesi Bassi
    {country: "NO", regex: "^\\+47(4\\d{7}|9\\d{7})$"},  // Norvegia
    {country: "PL", regex: "^\\+48(5[0-7]|6[0-4]|7[2-9]|8[0-9])\\d{7}$"}, // Polonia
    {country: "PT", regex: "^\\+351(9[1236]\\d{7})$"}, // Portogallo
    {country: "RO", regex: "^\\+40(7[0-8]\\d{7})$"}, // Romania
    {country: "SM", regex: "^\\+378(6\\d{8})$"}, // San Marino
    {country: "SK", regex: "^\\+421(9[0-9]\\d{7})$"}, // Slovacchia
    {country: "SI", regex: "^\\+386(3[1-5]|4[0-6]|7[0-9])\\d{6}$"}, // Slovenia
    {country: "ES", regex: "^\\+34(6|7)\\d{8}$"}, // Spagna
    {country: "SE", regex: "^\\+46(7\\d{8})$"}, // Svezia
    {country: "CH", regex: "^\\+41(7[5-9]\\d{7})$"}, // Svizzera
    {country: "GB", regex: "^\\+44(7\\d{9})$"}, // Regno Unito
    {country: "VA", regex: "^\\+39(6\\d{8})$"}, // Città del Vaticano
    {country: "ME", regex: "^\\+382(6\\d{7})$"} // Montenegro
];

export function isValidPhoneNumber(phoneNumber: string) {
    for(let validator of sepaPhoneValidators) {
        const phoneRegexp = new RegExp(validator.regex);
        if(phoneRegexp.test(phoneNumber)) {
            return true
        }
    }
    return false;
}